import { createSlice } from "@reduxjs/toolkit";

const searchCasesSlice = createSlice({
  name: "mySearchCases",
  initialState: {
    currPayload: false,
  },
  reducers: {
    setCurrPayload: (state, action) => {
      state.currPayload = action.payload;
    },
  },
});

export const { setCurrPayload } = searchCasesSlice.actions;
export default searchCasesSlice.reducer;
